import React from "react";

function Header(props) {
  return (
    <div className="w-100 absolute top-0 z-3 flex pa3-ns pa2 justify-between usn">
      {/* <div className="dn db-ns">
        <p className="pa0 ma0 f4">Geo Artworks</p>
        <p className="pa0 ma0 f6">Find where artworks were created!</p>
      </div> */}
      <div className="bg-custom-light-ns flex br2">
        <div className="f6 round mt3-ns mt1 mb3-ns mb1 pl4-ns pl2 pr4-ns pr2">
          <p className="pa0 ma0 tc">{props.i18n.round}</p>
          <p className="pa0 ma0 tc f5 b">{props.round + 1}/5</p>
        </div>
        <div className="f6 score mt3-ns mt1 mb3-ns mb1 pl4-ns pl2 pr4-ns pr2">
          <p className="pa0 ma0 tc">{props.i18n.score}</p>
          <p className="pa0 ma0 tc f5 b">{props.totalScore}</p>
        </div>
      </div>
    </div>
  );
}

export default Header;
